export const domainsInputBox = {
    fontSize: "10px",
    my: 3,
    "& .MuiOutlinedInput-input": {
        py: 0,
        fontSize: "14px",
    },
    "& .MuiOutlinedInput-root": {
        borderRadius: 5,
        borderWidth: 0.5,
    },
};

export const domainsInputPlaceholder =
    "mydomain1.com\nmydomain2.com , 2\nmydomain3.com , 1";

export const priorityTableRow = {
    "&:last-child td, &:last-child th": {
        border: 0,
    },
    height: "80px",
};

export const responseTableRow = {
    "&:last-child td, &:last-child th": {
        border: 0,
    },
    height: "70px",
};

export const prioritySelector = {
    fontSize: "12px",
    padding: 0,
    outlineColor: "white",
    width: "55px",
    textAlign: "center",
    transition: "all 0.3s",
    "& .MuiOutlinedInput-input": {
        py: "3px",
    },
    mx: 1,
};

export const deleteIcon = {
    color: "#3A3541CC",
    fontSize: "15px",
};

export const allBidsRowMenuStyles = {
    listButton: {
        display: "flex",
        px: 2,
        justifyContent: "flex-start",
        py: 1,
    },
    listText: {
        fontSize: "13px",
        ml: 1,
        color: "#3A354180",
        textTransform: "none",
    },
    list: {
        minWidth: "150px",
        fontSize: "13px",
    },
};

export const preBackorderInfoStyle = {
    fontFamily: "Public Sans, sans-serif",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "16px",
    letterSpacing: 0,
    color: "#3A3541CC",
};

export const preBackorderLearnMoreStyle = {
    textDecoration: "underline",
    fontFamily: "Public Sans, sans-serif",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "16px",
    letterSpacing: 0,
    color: "#FFB700",
    cursor: "pointer",
    textDecorationThickness: "1px",
    textUnderlineOffset: "2px",
    display: "inline",
};

export const preBackorderDomainInputBox = {
    fontSize: "10px",
    mt: 2,
    mb: 3,
    "& .MuiOutlinedInput-input": {
        py: 1,
        fontSize: "14px",
    },
    "& .MuiOutlinedInput-root": {
        borderRadius: 1,
        borderWidth: 1,
    },
    "& .MuiFormHelperText-root": {
        marginTop: "8px",
        marginLeft: 0,
    },
};

export const dateSelectBoxButtonTitleStyle = {
    fontSize: "14px",
    letterSpacing: 0,
    color: "#3A3541CC",
    minWidth: "120px",
};

export const dateSelectBoxButtonStyle = {
    fontSize: "13px",
    textAlign: "right",
    width: "120px",
    pt: "5px",
    pb: "5px",
    pl: "10px",
    pr: "10px",
    borderRadius: "20px",
    bgcolor: "#D9D9D93B",
    color: "#615D67",
    minHeight: "19.5px",
};

export const dateSelectDomainNameStyle = {
    fontSize: "13px",
    textAlign: "right",
    pt: "5px",
    pb: "5px",
    pl: "10px",
    pr: "10px",
    ml: "20px",
    color: "#615D67",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
};

export const preBackorderSelectedRowStyle = {
    backgroundColor: "#FFB70024 !important",
};
